import {
  SHOW_RESPONSE_MESSAGE,
  HIDE_RESPONSE_MESSAGE,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  GET_RESPONSE_SUCCESS,
  GET_RESPONSE_MODES_SUCCESS,
  SAVE_RESPONSE_SUCCESS,
  SAVE_RESPONSE_MOBILE_SUCCESS,
  SAVE_RESPONSE_MOBILE_TOKEN_SUCCESS,
  SAVE_RESPONSE_EMAIL_SUCCESS,
  SAVE_RESPONSE_EMAIL_TOKEN_SUCCESS,
  RETURN_APPLICATION,
  CANCEL_RETURN,
  SAVE_RESPONSE_FILE_SUCCESS,
  SAVE_RESPONSE_SIGNED_FILE_SUCCESS,
  DOWNLOAD_RESPONSE_SUCCESS,
} from '../constants/ActionTypes'
const download = require('downloadjs')

const INIT_STATE = {
  loader: false,
  alertType: '',
  alertMessage: '',
  showMessage: false,
  responseData: {},
  saveResult: {},
  mobileSaved: false,
  mobileVerified: false,
  mobileTokenExpired: false,
  emailSaved: false,
  emailVerified: false,
  emailTokenExpired: false,
  modes: [],
  returningSession: false,
  fileUploadResult: {},
  mobileSessionId: '',
  emailSessionId: '',
  signedFileUploadResult: null,
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_RESPONSE_SUCCESS: {
      return {
        ...state,
        loader: false,
        alertType: action.payload.status,
        alertMessage: action.payload.message,
        responseData: action.payload.data,
      }
    }

    case GET_RESPONSE_MODES_SUCCESS: {
      return {
        ...state,
        loader: false,
        modes: action.payload.data,
      }
    }

    case SAVE_RESPONSE_SUCCESS: {
      return {
        ...state,
        loader: false,
        alertType: action.payload.status,
        alertMessage: action.payload.message,
        saveResult: action.payload.data,
      }
    }

    case SAVE_RESPONSE_MOBILE_SUCCESS: {
      return {
        ...state,
        loader: false,
        saveResult: action.payload.data,
        alertMessage: action.payload.message,
        showMessage: false,
        mobileSaved: action.payload.status === "ok",
        mobileSessionId: action.payload.data?.id?.split(":")?.[1] ?? '',
        mobileTokenExpired: false,
      }
    }

    case SAVE_RESPONSE_MOBILE_TOKEN_SUCCESS: {
      return {
        ...state,
        loader: false,
        saveResult: action.payload.data,
        alertMessage: action.payload.message,
        showMessage: true,
        mobileVerified: action.payload.status === "ok",
        mobileTokenExpired: action.payload.status === "error" && action.payload.data?.token_expired,
      }
    }

    case SAVE_RESPONSE_EMAIL_SUCCESS: {
      return {
        ...state,
        loader: false,
        saveResult: action.payload.data,
        alertMessage: action.payload.message,
        showMessage: false,
        emailSaved: action.payload.status === "ok",
        emailSessionId: action.payload.data?.id?.split(":")?.[1] ?? '',
        emailTokenExpired: false,
      }
    }

    case SAVE_RESPONSE_EMAIL_TOKEN_SUCCESS: {
      return {
        ...state,
        loader: false,
        saveResult: action.payload.data,
        alertMessage: action.payload.message,
        showMessage: true,
        emailVerified: action.payload.status === "ok",
        emailTokenExpired: action.payload.status === "error" && action.payload.data?.token_expired,
      }
    }

    case SAVE_RESPONSE_FILE_SUCCESS: {
      return {
        ...state,
        loader: false,
        alertType: action.payload.status,
        alertMessage: action.payload.message,
        fileUploadResult: action.payload.data,
      }
    }

    case SAVE_RESPONSE_SIGNED_FILE_SUCCESS: {
      return {
        ...state,
        loader: false,
        alertType: action.payload.status,
        alertMessage: action.payload.message,
        signedFileUploadResult: action.payload.data,
      }
    }

    case DOWNLOAD_RESPONSE_SUCCESS: {
      const blob = action.payload
      if (blob.type === 'application/pdf') {
        download(blob, 'unpuzzle_form_responses.pdf', 'application/pdf')
        return {
          ...state,
          showMessage: false,
          export_loader: false,
        }
      }

      return {
        ...state,
        alertType: 'error',
        alertMessage: 'Cannot retrieve form responses.',
        showMessage: true,
        export_loader: false,
      }
    }

    case RETURN_APPLICATION: {
      return {
        ...state,
        returningSession: true,
      }
    }

    case CANCEL_RETURN: {
      return {
        ...state,
        returningSession: false,
      }
    }

    case SHOW_RESPONSE_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload.message,
        alertType: action.payload.status,
        showMessage: true,
        loader: false,
      }
    }

    case HIDE_RESPONSE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false,
      }
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      }
    }

    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      }
    }

    default:
      return state
  }
}
